import React, { useState } from 'react';
import { useRecoilState } from 'recoil';
import { UserState } from 'utils/recoil/user';
import { alertState } from 'utils/recoil/snackbar';
import { withLocale } from 'utils/hocs';
import { Form } from '../../../UI/Forms/Form/form';
import { UserDetailsHeader } from '../Header/userDetailsHeader';
import NoozApi from '../../../../services/NoozApi';

export const ProfileInfosForm = withLocale(({ form, label }) => {
  const { successLabels, errorLabels } = form;
  const [hasResetPassword, setHasResetPassword] = useState(false);
  const [alert, setAlert] = useRecoilState(alertState);
  const [user, setUser] = useRecoilState(UserState);

  const onSubmit = (data) => {
    setUser({ ...user, isLoading: true });
    NoozApi.put('/customers/current', data)
      .then((response) => {
        setUser({ ...user, isLoading: true });
        if (response.data) {
          setAlert({
            ...alert,
            show: true,
            type: 'success',
            title: successLabels && successLabels[0].text,
          });

          setUser({ ...user, ...response.data });
        }
      })
      .catch(({ response }) => {
        setUser({ ...user, isLoading: false });
        setAlert({
          ...alert,
          show: true,
          type: 'error',
          title: response?.data.error,
        });
      });
  };

  const onPasswordRecoverSubmit = () => {
    NoozApi.post('/auth/recover-password', {
      email: user.email,
    })
      .then((response) => {
        if (
          response.data.customerUserErrors &&
          response.data.customerUserErrors.length > 0
        ) {
          setAlert({
            ...alert,
            show: true,
            type: 'error',
            title: response.data.customerUserErrors[0].message,
          });
        } else {
          setAlert({
            ...alert,
            show: true,
            type: 'success',
            title: successLabels && successLabels[1].text,
          });
          setHasResetPassword(true);
        }
      })
      .catch(({ response }) => {
        setAlert({
          ...alert,
          show: true,
          type: 'error',
          title: `${errorLabels[0].text} : ${response?.data.error}`,
        });
      });
  };

  return (
    <div className='w-full pb-20'>
      <UserDetailsHeader label={label} />
      <Form
        {...form}
        isLoading={user.isLoading}
        onSubmit={onSubmit}
        onSubmitSecondary={onPasswordRecoverSubmit}
        defaultValues={{
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          phone: user.phone,
        }}
      />
    </div>
  );
});
